/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const salesRoutes = {
  path: '/sales',
  component: Layout,
  name: 'Sales',
  alwaysShow: true,
  meta: {
    title: 'Sales',
    icon: 'DataLine',
    permissions: ['sale_view', 'sale_register_view'],
  },
  children: [
    /** Settings managements */

    {
      path: 'list',
      component: () => import('../views/sale/List'),
      name: 'saleList',
      meta: {
        title: 'Sale List',
        icon: 'Memo',
        permissions: ['sale_view'],
      },
    },
    {
      path: 'create',
      component: () => import('../views/sale/Create'),
      name: 'createList',
      meta: { title: 'Create Sale', icon: 'Memo', permissions: ['sale_add'] },
    },
    {
      path: 'view/:id(\\d+)',
      component: () => import('../views/sale/View'),
      name: 'ViewSale',
      meta: {
        title: 'View Sale',
        noCache: true,
        permissions: ['sale_edit'],
      },
      hidden: true,
    },
    {
      path: 'register/list',
      component: () => import('../views/sale/RegisterList'),
      name: 'RegisterList',
      meta: {
        title: 'Sale Register List',
        icon: 'Memo',
        permissions: ['sale_register_view'],
      },
    },
    {
      path: 'sale-report',
      component: () => import('../views/sale/sale-report'),
      name: 'saleReport',
      meta: {
        title: 'Sale Report',
        icon: 'list',
        permissions: ['sale_view'],
      },
      hidden: true,
    },
    {
      path: 'returns/list',
      component: () => import('../views/sale-return/List'),
      name: 'saleReturnList',
      meta: { title: 'Sale Returns', icon: 'Memo', permissions: ['sale_view'] },
    },
    {
      path: 'returns/create/:sale_id',
      component: () => import('../views/sale-return/Create'),
      name: 'saleReturnCreate',
      meta: { title: 'Create Sale Return', icon: 'Memo', permissions: ['sale_add'] },
      hidden: true,
    },
    {
      path: 'returns/view/:id(\\d+)',
      component: () => import('../views/sale-return/View'),
      name: 'saleReturnView',
      meta: { title: 'View Sale Return', icon: 'Memo', permissions: ['sale_view'] },
      hidden: true,
    },
  ],
};

export default salesRoutes;
